export default () => ({
    schedules: null
})
